module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fm"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('b', [_vm._v("BOOK I")])]), _vm._v(" "), _c('p', {
    staticClass: "extract3"
  }, [_vm._v("Cast of Characters")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Wilhelm Krause: a Nazi general")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Rolf Hermann:Kapitänleutnant of the Nazi submarine "), _c('i', [_vm._v("U-127")])]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Helmut Meier: SS major and Krause’s right-hand man")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Franz Mueller:minister of foreign procurement for the Nazis")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Ricardo Von Bruhl: an old friend of Krause and president of Banco Nationale de")]), _vm._v(" "), _c('p', {
    staticClass: "extract3"
  }, [_vm._v("Buenos Aires")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Jacques Mollard: an innkeeper in Peillon")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Evelina Panelli: a young field worker in Peillon")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Nadia Panelli: her twin sister")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Johann Brandt: a top Nazi agent")]), _vm._v(" "), _c('p', {
    staticClass: "extract2"
  }, [_vm._v("Eduardo Diaz: an old friend of Krause")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb338e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/p01.vue
// module id = 69
// module chunks = 0